import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-secondary py-4 relative">
      <div className="text-center">
        <p>© {currentYear} Creative Town Bilingual School - Core Care and Education</p>
      </div>
      <div className="absolute bottom-4 right-4">
        <Link to="/admin" className="text-secondary hover:text-blue-300 font-semibold text-sm">Admin</Link>
      </div>
    </footer>
  );
};

export default Footer;
